import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { splayParams } from "../utils/splay-params";

@Injectable()
export class AttributeService {
  constructor(private http: HttpClient) {}

  public query(params: any) {
    let projectId;
    [params, projectId] = splayParams(params, "projectId");
    const url = `/api/v4/projects/${projectId}/attributes`;
    return this.http.get(url, { params });
  }

  public get(params: any) {
    let attrId: any;
    let projectId: any;
    [params, projectId, attrId] = splayParams(params, "projectId", "attrId");
    const url = `/api/v4/projects/${projectId}/attributes/${attrId}`;
    return this.http.get(url, { params });
  }
}
